import MobileSheet from './MobileSheet';
import ConfirmModal from '../ConfirmModal';
import UserAvatar from '../UserAvatar';
import CustomSelect from '../CustomSelect';
import { UserPlusIcon, DeleteIcon } from './Icons';
import useUserManagement, { ROLE_OPTIONS } from '../../hooks/useUserManagement';

export default function UserManagementMobile({ users, onClose, onUsersChanged, showToast }) {
  const {
    showAddForm, setShowAddForm, email, setEmail, displayName, setDisplayName,
    password, setPassword, role, setRole, saving, deleteTarget, setDeleteTarget,
    handleAddUser, handleRoleChange, handleDeleteUser,
  } = useUserManagement({ onUsersChanged, showToast });

  if (showAddForm) {
    return (
      <>
        <MobileSheet title="Add User" onClose={() => setShowAddForm(false)}>
          <div className="mobile-form">
            <div className="mobile-input-group">
              <label className="mobile-label">Display Name</label>
              <input
                className="mobile-input"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="Full name"
              />
            </div>
            <div className="mobile-input-group">
              <label className="mobile-label">Email</label>
              <input
                className="mobile-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
              />
            </div>
            <div className="mobile-input-group">
              <label className="mobile-label">Temporary Password</label>
              <input
                className="mobile-input"
                type="text"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min 6 characters"
              />
            </div>
            <div className="mobile-input-group">
              <label className="mobile-label">Role</label>
              <CustomSelect value={role} onChange={setRole} options={ROLE_OPTIONS} />
            </div>
            <button
              className="mobile-btn mobile-btn-primary"
              onClick={handleAddUser}
              disabled={saving || !email.trim() || !displayName.trim() || !password.trim()}
            >
              {saving ? 'Creating...' : 'Create User'}
            </button>
          </div>
        </MobileSheet>
        {deleteTarget && (
          <ConfirmModal
            message="Remove this user?"
            onConfirm={handleDeleteUser}
            onCancel={() => setDeleteTarget(null)}
            confirmLabel="Remove"
          />
        )}
      </>
    );
  }

  return (
    <>
      <MobileSheet
        title="Users"
        onClose={onClose}
        showFooter
        footer={
          <button className="mobile-btn mobile-btn-primary" onClick={() => setShowAddForm(true)}>
            <UserPlusIcon size={16} /> Add User
          </button>
        }
      >
        <div className="mobile-user-list">
          {users.map((u) => (
            <div key={u.uid} className="mobile-user-item">
              <UserAvatar user={u} size={48} />
              <div className="mobile-user-item-info">
                <div className="mobile-user-item-name">{u.displayName}</div>
                <div className="mobile-user-item-email">{u.email}</div>
              </div>
              <div className="mobile-user-item-actions">
                <CustomSelect
                  value={u.role}
                  onChange={(val) => handleRoleChange(u.uid, val)}
                  options={ROLE_OPTIONS}
                  size="sm"
                  compact
                />
                <button className="mobile-btn-icon" onClick={() => setDeleteTarget(u.uid)} style={{ width: 36, height: 36 }}>
                  <DeleteIcon size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </MobileSheet>

      {deleteTarget && (
        <ConfirmModal
          message="Remove this user from the board?"
          onConfirm={handleDeleteUser}
          onCancel={() => setDeleteTarget(null)}
          confirmLabel="Remove"
        />
      )}
    </>
  );
}
